<template>
  <div>
    <a-row>
      <a-tabs defaultActiveKey="1">
        <a-tab-pane tab="VALORES ADICIONALES POR EMPLEADO" key="1">
          <g-master name="forms"
                    :endpoint="master.endpoint"
                    :tableSetup="master.tableSetup"
                    :modalFieldsSetup="master.modalFieldsSetup"
                    @action="masterAction"
                    ref="master"
                    modalWidth="70%"
          >
            <template slot="customButton">
              <g-btn-excel :endpoint="endpointExcel" :params="paramsExcel" :fileName="fileNameExcel"/>
            </template>
            <template slot="masterModal" slot-scope="{record}">
              <a-row :gutter="[16,16]">
                <a-col v-bind="colOptions">
                  <g-lookup :label="$t('Empleado')"
                            :formItemConfig="fiOptions"
                            endpoint="empleados"
                            :decorator="['id_emp', { rules: [{ required: true, message: 'Valor requerido' }]}]"
                  >
                  </g-lookup>
                </a-col>
                <a-col v-bind="colOptions">
                  <g-lookup endpoint="coc"
                            :label="$t('Concepto')"
                            :formItemConfig="fiOptions"
                            :decorator="['id_coc', { rules: [{ required: true, message: 'Valor requerido' }] }]"
                  >
                  </g-lookup>
                </a-col>
                <a-col v-bind="colOptions">
                  <a-form-item :label="$t('Valor')" v-bind="fiOptions">
                    <a-input-number
                      v-decorator="['valor', { rules: [
                            { required: false},
                           ] }]"
                      style="width: 100%">
                    </a-input-number>
                  </a-form-item>
                </a-col>
                <a-col v-bind="colOptions">
                  <g-dropdown endpoint="hierarchy_lookup"
                              label="Retroactivo"
                              :formItemConfig="fiOptions" :params="estadoSN"
                              :decorator="['retro', { rules: [{ required: false }] }]"
                  >
                  </g-dropdown>
                </a-col>
                <a-col v-bind="colOptions">
                  <a-form-item v-bind="fiOptions" :label="$t('Fecha Inicial')">
                    <a-date-picker style="width: 100%"
                                   type="date"
                                   valueFormat="Y-MM-DD"
                                   v-decorator="['init_date', { rules: [{ required: false }] }]"/>
                  </a-form-item>
                </a-col>
                <a-col v-bind="colOptions">
                  <a-form-item v-bind="fiOptions" :label="$t('Fecha Reporte Aumento')">
                    <a-date-picker style="width: 100%"
                                   type="date"
                                   valueFormat="Y-MM-DD"
                                   v-decorator="['date_rep', { rules: [{ required: false }] }]"/>
                  </a-form-item>
                </a-col>
                <a-col v-bind="colOptions">
                  <a-form-item v-bind="fiOptions" :label="$t('Seleccione una opción')">
                    <a-radio-group v-decorator="['columna_seleccionada']">
                      <a-radio value="prop_dias_lab">
                        pr_dias
                      </a-radio>
                      <a-radio value="por_turno_lab">
                        x_turno
                      </a-radio>
                      <a-radio value="val_fijo_per">
                        val_fijo
                      </a-radio>
                      <a-radio value="val_fijo_2q">
                        val_fijo_2q
                      </a-radio>
                      <a-radio value="prop_dias_lab_2q">
                        pr_dias_2q
                      </a-radio>
                      <a-radio value="por_turno_lab_2q">
                        x_turno_2q
                      </a-radio>
                    </a-radio-group>
                  </a-form-item>
                </a-col>
              </a-row>
            </template>
          </g-master>
        </a-tab-pane>
      </a-tabs>
    </a-row>
    <a-row>
    </a-row>
    <!-- NUEVO MODAL -->
    <a-modal
      :visible="visible"
      title='Crear / Editar'
      okText='Ok'
      width="50%"
      :confirm-loading="loading"
      @cancel="handleCancel"
      @ok="editarValadicEmp()"
    >
      <a-form-model :model="iValadicXEmp" v-bind="fiOptions" :rules="formRules"
                    @submit.native.prevent ref="valdicEmp">
        <a-row :gutter="[16,16]">
          <a-col v-bind="colConfig2">
            <a-form-model-item v-bind="fiOptions" :label="$t('Valor')" >
              <a-input-number style="width: 100%" step="1"
                              v-model=iValadicXEmp.valor>
              </a-input-number>
            </a-form-model-item>
          </a-col>
          <a-col v-bind="colSpan">
            <a-form-item :label="$t('Retroactivo')" prop="retro">
              <form-model-dropdown style="width: 100%"
                                   endpoint="hierarchy_lookup"
                                   v-model="iValadicXEmp.retro"
                                   :params="estadoSN"
              >
              </form-model-dropdown>
            </a-form-item>
          </a-col>
          <a-col v-bind="colSpan">
            <a-form-model-item :label="$t('Fecha Inicial')" prop="init_date" >
              <a-date-picker style="width: 100%"
                             type="date"
                             valueFormat="Y-MM-DD"
                             v-model="iValadicXEmp.init_date"/>
            </a-form-model-item>
          </a-col>
          <a-col v-bind="colSpan">
            <a-form-model-item :label="$t('Fecha Reporte Aumento')" prop="date_rep" >
              <a-date-picker style="width: 100%"
                             type="date"
                             valueFormat="Y-MM-DD"
                             v-model="iValadicXEmp.date_rep"/>
            </a-form-model-item>
          </a-col>
          <a-col v-bind="colConfig2">
            <a-form-model-item v-bind="fiOptions" :label="$t('Seleccione una opción')" prop="columnaseleccionada">
              <a-radio-group v-model="valueRadio">
                <a-radio value="prop_dias_lab">
                  pr_dias
                </a-radio>
                <a-radio value="por_turno_lab">
                  x_turno
                </a-radio>
                <a-radio value="val_fijo_per">
                  val_fijo
                </a-radio>
                <a-radio value="val_fijo_2q">
                  val_fijo_2q
                </a-radio>
                <a-radio value="prop_dias_lab_2q">
                  pr_dias_2q
                </a-radio>
                <a-radio value="por_turno_lab_2q">
                  x_turno_2q
                </a-radio>
              </a-radio-group>
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
    </a-modal>
  </div>
</template>

<script>
  import HttpUtil from '@/util/HttpUtil'
  import Mensajes from 'CustomModules/GlobalBPOCore/Util/Mensajes'

  export default {
    data () {
      return {
        estadoSN: {
          h_lookup_type: 'ESTADO_SN',
          use_code: true
        },
        loading: false,
        valueRadio: null,
        colConfig: {
          sm: 24,
          md: 12
        },
        colConfig2: {
          sm: 24,
          md: 24
        },
        iValadicXEmp: {},
        formRules: {},
        visible: false,
        checkVal_fijo_per: false,
        checkProp_dias_lab: false,
        checkProp_turno_lab: false,
        checkVal_fijo_2q: false,
        checkProp_dias_lab_2q: false,
        checkPor_turno_lab_2q: false,
        colOptions: {xs: 24, sm: 24},
        fiOptions: {
          'label-col': {},
          'wrapper-col': {}
        },
        master: {
          endpoint: 'valadic_x_emp',
          tableSetup: {
            actions: {
              actions: [
                {
                  name: 'editar',
                  text: 'Editar',
                  permisos: [],
                  props: {size: 'small', type: 'link', icon: 'edit'}
                },
                {
                  name: 'customDelete',
                  text: 'Eliminar',
                  permisos: [],
                  props: {size: 'small', icon: 'delete', type: 'link'}
                }
              ]
            },
            tableConfig: {
              pagination: {
                pageSize: 5,
                current: 1,
                pageSizeOptions: ['5', '10', '20', '40', '100', '200'],
                showTotal: (total, range) => `${range[0]}-${range[1]} de ${total} registros`,
                showSizeChanger: true
              },
              rowKey: 'id'
            },
            columns: [
              {title: 'Cédula', dataIndex: 'id_emp', sorter: true},
              {title: 'Nombre completo', dataIndex: 'nombre_completo', sorter: true},
              {title: 'ID concepto', dataIndex: 'id_coc', sorter: true},
              {title: 'Nombre concepto', dataIndex: 'nombre_coc', sorter: true},
              {title: 'Valor', dataIndex: 'valor', sorter: true},
              {title: 'pr_dias', dataIndex: 'prop_dias_lab', sorter: true},
              {title: 'x_turno', dataIndex: 'por_turno_lab', sorter: true},
              {title: 'val_fijo', dataIndex: 'val_fijo_per', sorter: true},
              {title: 'val_fijo_2q', dataIndex: 'val_fijo_2q', sorter: true},
              {title: 'pr_dias_2q', dataIndex: 'prop_dias_lab_2q', sorter: true},
              {title: 'x_turno_2q', dataIndex: 'por_turno_lab_2q', sorter: true},
              {title: 'Retroactivo', dataIndex: 'retro_desc', sorter: true},
              {title: 'Fecha Inicial', dataIndex: 'init_date_format', sorter: true},
              {title: 'Fecha Reporte Aumento', dataIndex: 'date_rep_format', sorter: true}
            ]
          },
          modalFieldsSetup: [
            {name: 'id_emp'},
            {name: 'id_coc'},
            {name: 'valor'},
            {name: 'prop_dias_lab', type: 'boolean'},
            {name: 'por_turno_lab', type: 'boolean'},
            {name: 'val_fijo_per', type: 'boolean'},
            {name: 'val_fijo_2q', type: 'boolean'},
            {name: 'prop_dias_lab_2q', type: 'boolean'},
            {name: 'por_turno_lab_2q', type: 'boolean'},
            {name: 'retro'},
            {name: 'init_date'},
            {name: 'date_rep'}
          ]
        },
        paramsT: {},
        endpointExcel: 'valadic_x_emp_/downloadExcel',
        fileNameExcel: 'AdicionalesPorEmpleado'
      }
    },
    mounted () {
      this.httpClient = new HttpUtil()
      this.initFormRules()
    },
    methods: {
      handleCancel (e) {
        this.visible = false
      },
      editarValadicEmp () {
        this.loading = true
        this.$refs.valdicEmp.validate(valid => {
          if (valid) {
            return new Promise((resolve, reject) => {
              this.httpClient.getInstance().put('valadic_x_emp/act', {
                id_coc: this.iValadicXEmp.id_coc,
                id_emp: this.iValadicXEmp.id_emp,
                valor: this.iValadicXEmp.valor,
                retro: this.iValadicXEmp.retro,
                init_date: this.iValadicXEmp.init_date,
                date_rep: this.iValadicXEmp.date_rep,
                columna_seleccionada: this.valueRadio
              })
                .then(() => {
                  this.$refs.master.$refs.datatable.loadData()
                  resolve()
                  this.loading = false
                  this.visible = false
                })
                .catch((error) => {
                  Mensajes.error('Error', 'No fue posible actualizar')
                  reject(error)
                  this.loading = false
                  this.visible = false
                })
            })
          }
        })
      },
      initFormRules () {
        this.formRules = {
          valor: [{required: false}],
          retro: [{required: false}],
          init_date: [{required: false}],
          date_rep: [{required: false}]
        }
      },
      masterAction (action) {
        switch (action.action) {
          case 'customDelete':
            this.$confirm({
              title: 'Confirmación',
              content: '¿Está seguro que desea eliminar el registro?',
              onOk: () => {
                return new Promise((resolve, reject) => {
                  this.httpClient.getInstance().delete('valadic_x_emp/rnd', {
                    data: action.record
                  })
                    .then(() => {
                      this.$refs.master.$refs.datatable.loadData()
                      resolve()
                    })
                    .catch((error) => {
                      Mensajes.error('Error', 'No fue posible eliminar el registro')
                      reject(error)
                    })
                })
              },
              onCancel () { }
            })
            break
          case 'editar':
            this.visible = true
            this.iValadicXEmp = {...action.record}
            this.isSelected()
            break
        }
      },

      isSelected () {
        if (this.iValadicXEmp.prop_dias_lab === 'X') {
          this.valueRadio = 'prop_dias_lab'
        } else if (this.iValadicXEmp.por_turno_lab === 'X') {
          this.valueRadio = 'por_turno_lab'
        } else if (this.iValadicXEmp.val_fijo_per === 'X') {
          this.valueRadio = 'val_fijo_per'
        } else if (this.iValadicXEmp.val_fijo_2q === 'X') {
          this.valueRadio = 'val_fijo_2q'
        } else if (this.iValadicXEmp.prop_dias_lab_2q === 'X') {
          this.valueRadio = 'prop_dias_lab_2q'
        } else if (this.iValadicXEmp.por_turno_lab_2q === 'X') {
          this.valueRadio = 'por_turno_lab_2q'
        }
      }
    },
    computed: {
      paramsExcel () {
        return {...this.paramsT, columns: this.master.tableSetup.columns}
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/Mantenimiento/ValadicXEmp/ValadicXEmp.vue